// src/pages/HistoryPageChina.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Ancient_Civilizations_-_Mesoamerica.png';

export default function HistoryPageMesoamerica() {
  return (
    <TopicPage
      topicKey="Mesoamerica"
      title="History: Ancient Mesoamerica"
      backgroundImage={bg}
      startRoute="/History-Ancient-Mesoamerica-Go"
      scrollLabels={[
        "Mississippian Culture",
        "Teotihuacan",
        "Civilizations",
      ]}
  backRoute="/history-Ancient-Civilizations"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
